import {GenericPopupModule} from '@gongxigames/framework/slot';
import {IGameGenericPopupConfig} from 'src/configs/PopupConfig';

export class GameGenericPopupModule extends GenericPopupModule {
    public getConfigByType(type: Symbol, value?: string, ...args: any[]): any {
        const popupConfig = super.getConfigByType(type, value, ...args) as IGameGenericPopupConfig;

        if (popupConfig) {
            if (args.length > 0) {
                const type = args[0];

                popupConfig.spine.forEach((spine) => {
                    if (spine.typedAnimation) {
                        const {start, idle} = spine.typedAnimation;
                        const getNameFromTypedAnimation = (array: any[]) => array.find(value => value.type === type).name;

                        spine.animation = {
                            start: start && getNameFromTypedAnimation(start),
                            idle: idle && getNameFromTypedAnimation(idle)
                        };
                    }
                });
            }
        }

        return popupConfig;
    }
}
